import styled from "styled-components";
import GradientSection from "./GradientSection";

const ContactContainer = styled.div`
    display: flex;
    margin-top: 50px !important;

    & > * {
        width: 100%;
    }

    section {
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
    }

    header {
        font-weight: bold;
        color: #fff;
        font-size: 3.2rem;
        padding: 80px 30px;
    }

    main {
        padding: 25px 150px 15px 80px;
    }

    .action-section button {
        padding-left: 60px;
        padding-right: 60px;
        margin-top: 50px;
    }

    h2 {
        margin-bottom: 30px;
    }

    @media (max-width: 700px) {
        flex-direction: column;

        header {
            font-size: 2rem;
            padding: 50px 30px;
        }

        section {
            width: calc(100% - 15px);
        }

        main {
            padding: 15px;
        }

        .action-section {
            text-align: center;
        }
    }
`;

type ContactSectionProps = {
    title: string;
    children: any;
};

const ContactSection: React.FC<ContactSectionProps> = ({ title, children }) => {
    return (
        <ContactContainer className="container">
            <GradientSection fromColor="#DE1D1D" toColor="#FF5701">
                <header>
                    {title}
                </header>
            </GradientSection>

            <main>
                {children}
            </main>
        </ContactContainer>
    );
};

export default ContactSection;
